var map = {
	"./AITranslate-active.png": "2049",
	"./AITranslate.png": "1bf5",
	"./convert-active.png": "19b7",
	"./convert.png": "1fe9",
	"./doc-active.png": "ae60",
	"./doc.png": "c28e",
	"./img-active.png": "ded8",
	"./img.png": "d84a",
	"./more-active.png": "ba73",
	"./more.png": "0c56",
	"./polish-active.png": "6d61",
	"./polish.png": "882f",
	"./pro-active.png": "cb56",
	"./pro.png": "41af",
	"./setting-active.png": "d0bd",
	"./setting.png": "bb26",
	"./txt-active.png": "77f0",
	"./txt.png": "f525"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "14b5";